import { render, staticRenderFns } from "./PopupInputControlDocs.vue?vue&type=template&id=c2da1258"
import script from "./PopupInputControlDocs.vue?vue&type=script&lang=ts"
export * from "./PopupInputControlDocs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports